import Index from 'src/pages/Warehouses/Index.vue'
import Create from 'src/pages/Warehouses/Create.vue'
import Edit from 'src/pages/Warehouses/Edit.vue'
import Restore from 'src/pages/Warehouses/Restore.vue'

const auth = { requiresAuth: true }

export default [
  {
    path: '/warehouses',
    name: 'Lager',
    component: Index,
    meta: auth
  },
  {
    path: '/warehouses/create',
    name: 'Lager Erstellen',
    component: Create,
    meta: auth
  },
  {
    path: '/warehouses/restore',
    name: 'Lager Zurücksetzen',
    component: Restore,
    meta: auth
  },
  {
    path: '/warehouses/:id/edit',
    name: 'Lager Bearbeiten',
    component: Edit,
    meta: auth
  }
]
